import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../../helpers/export'
import BankService from '../../core/BankService'

export const postEarningQuality = createAsyncThunk(
  'companyAnalysis/industryAnalysis/bank/earningQuality',
  async (params, { rejectWithValue }) => {
    try {
      const res = await BankService.postEarningQuality(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadEarningQuality = createAsyncThunk(
  'companyAnalysis/industryAnalysis/corp/earningQuality/export',
  async (params) => {
    try {
      const res = await BankService.downloadEarningQuality(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
